import { useTranslation } from 'react-i18next';
import { useParams, useSearchParams } from 'react-router-dom';
import type { DocumentVersionDto } from '@monorepo/shared';
import { useSelectedCompanyStore } from '../stores/selectedCompany.store';
import { useListVersions, useGetVersionPresignedUrl } from '../services/documents.service';
import { DocumentVersionsTable } from '../components/documents/DocumentVersionsTable';

export const DocumentVersionsPage = () => {
  const { t } = useTranslation();
  const { documentId } = useParams<{ documentId: string }>();
  const [searchParams] = useSearchParams();
  const documentName = searchParams.get('name') ?? '';
  const selectedCompanyId = useSelectedCompanyStore((state) => state.selectedCompanyId);

  const { data, isLoading } = useListVersions(selectedCompanyId ?? '', documentId ?? '');
  const getVersionPresignedUrlMutation = useGetVersionPresignedUrl(selectedCompanyId ?? '');

  const handleDownload = async (version: DocumentVersionDto) => {
    if (!documentId) return;
    try {
      const result = await getVersionPresignedUrlMutation.mutateAsync({
        documentId,
        versionId: version.id,
      });
      window.open(result.url, '_blank');
    } catch (error) {
      console.error('Error downloading version:', error);
    }
  };

  return (
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
      <h1 className="text-2xl font-bold text-gray-900 mb-1">
        {t('documents.document_versions.title')}
      </h1>
      {documentName && <p className="text-sm text-gray-500 mb-6">{documentName}</p>}

      <DocumentVersionsTable
        versions={data?.versions ?? []}
        isLoading={isLoading}
        isDownloading={getVersionPresignedUrlMutation.isPending}
        onDownload={handleDownload}
      />
    </div>
  );
};
